// Entitlements
export const UPDATE_ENTITLEMENTS = 'UPDATE_ENTITLEMENTS';
export const CLEAR_ENTITLEMENTS = 'CLEAR_ENTITLEMENTS';

// get payment history
export const GET_PAYMENT_REQUEST = 'GET_PAYMENT_REQUEST';
export const GET_PAYMENT_SUCCESS = 'GET_PAYMENT_SUCCESS';
export const GET_PAYMENT_ERROR = 'GET_PAYMENT_ERROR';
export const CLEAR_PAYMENT_HISTORY = 'CLEAR_PAYMENT_HISTORY';

// get payment methods
export const GET_PAYMENT_METHOD_REQUEST = 'GET_PAYMENT_METHOD_REQUEST';
export const GET_PAYMENT_METHOD_SUCCESS = 'GET_PAYMENT_METHOD_SUCCESS';
export const GET_PAYMENT_METHOD_ERROR = 'GET_PAYMENT_METHOD_ERROR';

// clear payment methods
export const CLEAR_PAYMENT_METHODS = 'CLEAR_PAYMENT_METHODS';
export const SET_PAYPAL_ERROR = 'SET_PAYPAL_ERROR';

// subscriptions
export const SUBSCRIPTION_REQUEST = 'SUBSCRIPTION_REQUEST';
export const SUBSCRIPTION_STATUS_REQUEST = 'SUBSCRIPTION_STATUS_REQUEST';
export const SUBSCRIPTION_SUCCESS = 'SUBSCRIPTION_SUCCESS';
export const SUBSCRIPTION_ERROR = 'SUBSCRIPTION_ERROR';
export const SUBSCRIPTION_STATUS_SUCCESS = 'SUBSCRIPTION_STATUS_SUCCESS';
export const CLEAR_SUBSCRIPTION = 'CLEAR_SUBSCRIPTION';
